export const USE_EMULATOR = import.meta.env.VITE_USE_EMULATOR === "true";
export const PAYLOAD_URL = import.meta.env.VITE_PAYLOAD_URL;
